/**
 * GuidelinesPersonalizationModal styled components
 */

import styled from 'styled-components'
import Modal from 'antd/lib/modal'
import { PrimaryCTA, SecondaryCTA } from '../../theme/components'

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0;
    border: var(--border-regular) solid var(--neutral-border-light);
    box-shadow: 0 16px 16px rgba(10, 10, 9, 0.08);
  }
  .ant-modal-body {
    padding: 0;
  }
  @media (max-width: 767px) {
    width: calc(100vw - 40px) !important;
    max-width: 100%;
    .ant-modal-content {
      box-shadow: 0 12px 12px rgba(10, 10, 9, 0.1);
    }
  }
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-24);
  padding: var(--spacing-32);
  @media (max-width: 767px) {
    gap: var(--spacing-16);
    padding: var(--spacing-24) 20px;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  min-height: 24px;
  @media (max-width: 767px) {
    min-height: 18px;
  }
  .red-line {
    width: 48px;
    height: 4px;
    flex-shrink: 0;
    background: var(--accent-red);
  }
`

export const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
  max-width: 24px;
  cursor: pointer;
  flex-shrink: 0;
  @media (max-width: 767px) {
    width: 18px;
    height: 18px;
    max-width: 18px;
  }
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  width: 100%;
  @media (max-width: 767px) {
    gap: var(--spacing-16);
  }
  .title {
    margin: 0;
    width: 100%;
    color: var(--neutral-darkest);
    font: 600 32px/38px var(--font-barlow-semi-condensed);
    text-transform: capitalize;
  }
`

export const Guidelines = styled.div`
  color: var(--neutral-body);
  font: 400 14px/22px var(--font-inter);
  width: 100%;
  @media (max-width: 767px) {
    font: 400 12px/20px var(--font-inter);
  }
  .intro {
    margin: 0;
  }
  .emphasis {
    color: var(--neutral-darkest);
    font-weight: 600;
  }
`

export const Rules = styled.ol`
  margin: 0;
  padding-left: 1.5em;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
    margin-top: var(--spacing-4);
    padding-left: 0;
    list-style: none;
    counter-reset: guidelines;
  }
`

export const Rule = styled.li`
  @media (max-width: 767px) {
    display: flex;
    gap: 6px;
    align-items: flex-start;
    counter-increment: guidelines;
    &::before {
      content: counter(guidelines) '.';
      color: var(--neutral-secondary);
      flex-shrink: 0;
    }
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-12);
  width: 100%;
  @media (max-width: 767px) {
    flex-direction: column-reverse;
    gap: var(--spacing-8);
    padding-top: var(--spacing-4);
  }
`

export const CancelButton = styled(SecondaryCTA)`
  flex: 1 0 0;
  min-width: 0;
  width: auto;
  max-width: none;
  @media (max-width: 767px) {
    width: 100%;
    flex: none;
  }
`

export const ProceedButton = styled(PrimaryCTA)`
  flex: 1 0 0;
  min-width: 0;
  width: auto;
  max-width: none;
  @media (max-width: 767px) {
    width: 100%;
    flex: none;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/GuidelinesPersonalizationModal/styledComponents.tsx